import './addBasicInfo.scss';

export const AddBasicInfoComponent = {
    template: `
    <ng-form name="$ctrl.addBasicInfoForm">
    <div class="flex-row">
        <div class="column column-md-6 column-sm-12">
            <oo-input-container>
                <input
                    autocomplete="given-name"
                    id="fname"
                    name="fname"
                    ng-model="$ctrl.basicInfoService.data.firstName"
                    required maxlength="255"
                    type="text"
                />
                <label>First Name</label>
                <div ng-messages="$ctrl.addBasicInfoForm.fname.$error">
                    <div ng-messages-include="generic-messages"></div>
                </div>
            </oo-input-container>
        </div>
        <div class="column column-md-6 column-sm-12">
            <oo-input-container>
                <input
                    autocomplete="family-name"
                    id="user-name-last"
                    name="lname"
                    ng-model="$ctrl.basicInfoService.data.lastName"
                    required maxlength="255"
                    type="text"
                />
                <label>Last Name</label>
                <div ng-messages="$ctrl.addBasicInfoForm.lname.$error">
                    <div ng-messages-include="generic-messages"></div>
                </div>
            </oo-input-container>
        </div>
        <div class="column column-md-6 column-sm-12">
            <oo-input-container>
                <input
                    autocomplete="email"
                    id="user-email"
                    name="email"
                    ng-disabled="$ctrl.disableEmail"
                    ng-model="$ctrl.basicInfoService.data.email"
                    ng-pattern="$ctrl.basicInfoService.emailPattern"
                    required
                    type="email"
                />
                <label>Email</label>
                <div ng-messages="$ctrl.addBasicInfoForm.email.$error">
                    <div ng-messages-include="generic-messages"></div>
                    <div ng-message="email, pattern">Enter a valid email address</div>
                </div>
            </oo-input-container>
        </div>
        <div class="column column-md-6 column-sm-12">
            <oo-input-container>
                <input
                    autocomplete="tel-national"
                    id="phone"
                    name="phone"
                    ng-model="$ctrl.basicInfoService.data.phoneNumber"
                    placeholder=" "
                    required
                    type="tel"
                    ui-mask-placeholder-char="space"
                    ui-mask-placeholder="xxx-xxx-xxxx"
                    ui-mask="999-999-9999"
                    ui-options="$ctrl.options"
                    valid-phone-number
                />
                <label>Phone Number</label>
                <div ng-messages="$ctrl.addBasicInfoForm.phone.$error">
                    <div ng-messages-include="generic-messages"></div>
                    <div ng-message="firstNumberError">The first number cannot be 0 or 1</div>
                    <div ng-message="mask">Enter a valid phone number</div>
                </div>
            </oo-input-container>
        </div>
    </div>
    </ng-form>
    `,
    bindings: {
        disableEmail: '<'
    },
    controller: class {
        constructor(basicInfoService) {
            'ngInject';
            Object.assign(this, { basicInfoService });
            // TODO consolidate common options.
            this.options = { clearOnBlur: false, allowInvalidValue: true, addDefaultPlaceholder: false };
        }
    }
};
